import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-comercios',
  templateUrl: './menu-comercios.component.html',
  styleUrls: ['./menu-comercios.component.scss'],
})
export class MenuComerciosComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
